module.exports = __webpack_public_path__ + "static/media/James Wacksman Headshot_1681113602599.31d86a27.png";